import { memo, useCallback, useMemo } from 'react';
import {
  VideoElement,
  VideoStyleProperties
} from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Element/VideoElement';
import PlayerMenuTooltip from '@/App/remotion/components/PlayerMenus/PlayerMenuTooltip';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { classnames } from '@/libs/utils';
import { changeElementPositionHandler } from '@/Pages/Clip/ClipPlayer/ClipAssets/handlers';
import { DEFAULT_VIDEO_CONTAINER_STYLE } from '@/Pages/Clip/ClipPlayer/ClipAssets/constants';
import Icon from '@/components/atoms/Icon';

function VideoElementFill({ selectedElement }: { selectedElement: VideoElement }) {
  const { clipId, clipData } = useClipsContext();

  const currentFill = useMemo(() => selectedElement?.style?.objectFit, [selectedElement?.style?.objectFit]);

  const isCurrentlyFilled = useMemo(() => {
    return currentFill === 'cover';
  }, [currentFill]);

  const toggleFill = useCallback(() => {
    if (!selectedElement?.id) {
      return;
    }

    const newContainerStyle: VideoStyleProperties = isCurrentlyFilled
      ? {
          position: 'absolute',
          top: '10%',
          left: '10%',
          width: '80%',
          height: '80%'
        }
      : { ...DEFAULT_VIDEO_CONTAINER_STYLE };

    const newStyle: VideoStyleProperties = {
      objectFit: isCurrentlyFilled ? 'contain' : 'cover'
    };

    changeElementPositionHandler(clipData, clipId, selectedElement.id, {
      containerStyle: newContainerStyle,
      style: newStyle
    });
  }, [clipId, selectedElement?.id, clipData, isCurrentlyFilled]);

  return (
    <button
      onClick={toggleFill}
      data-testid="video-element-fill-toggle"
      className={classnames('group/button flex size-10 items-center justify-center rounded-md')}
    >
      <Icon name="IconRectangle" size={20} />
      <PlayerMenuTooltip content="Fill frame" />
    </button>
  );
}

export default memo(VideoElementFill);
